import { getAdMarketPublishGroupCode } from './getCommonAdProperties';
import { isGdprAdMarket } from './isGdprAdMarket';

export function isEUEmailAdsPolicyMarket() {
    const marketPublishGroupCode = getAdMarketPublishGroupCode();
    let countryCode: string;
    if (marketPublishGroupCode) {
        countryCode = marketPublishGroupCode.toUpperCase().split('-')[1];
    }

    // Exclude GB from EU from the GDPR country. If it turns out GB needs to apply the policy, we can use the same check as isGdprAdMarket
    if (countryCode === 'GB') {
        return false;
    }

    return isGdprAdMarket();
}
